import {useState,useEffect,useRef} from 'react'

export const PortfolioWorksSection=()=>{
    
    const [scrollVal,setScrollVar]=useState(0)
    const [sldierCards,setSliderCards]=useState([1,2,3,4,5,6,7,8,9])
    const [cardsCaruouselCapacity,setCardsCaruouselCapacity]=useState(0)
    const cardsPlaceHolderRef=useRef<HTMLDivElement>(null)
    const imageScale={
        width:window.innerWidth<=992?340:420,
        height:440
    }
    useEffect(()=>{
        console.log(Math.floor(cardsPlaceHolderRef.current!.offsetWidth/390))
       
        setCardsCaruouselCapacity(Math.floor(cardsPlaceHolderRef.current!.offsetWidth/390))
    },[])
    const sliderhandler=(actionType:string)=>{
        let arg=window.innerWidth<=992?-1:0
        switch(actionType){
            
          case 'scrollBack':
            //let arg=window.innerWidth<=992?-1:0
            if(0==scrollVal){
                setScrollVar(-((sldierCards.length-(cardsCaruouselCapacity+(-1-arg)))*imageScale.width-imageScale.width))
            }
            else{
                setScrollVar(scrollVal+imageScale.width)
            }
            break;
          case 'scrollForward':
            
            //let arg=window.innerWidth<=992?-1:0
            console.log(arg,window.innerWidth)
            if((sldierCards.length-(cardsCaruouselCapacity+(-1-arg)))*imageScale.width-imageScale.width==-scrollVal){
                setScrollVar(0)
            }else{
                setScrollVar(scrollVal-imageScale.width)
            }
            break;
        }
      }



    return(
        <div className="portfolio-works-section __container">
            <div className="portfolio-works-section_header">
                <h1>Browse our selected projects 
                and learn more about our work</h1>    
            </div>  
            <div className="portfolio-works-section_body">
                <div className="portfolio-works-section_cards-navigation">
                    <svg onClick={()=>sliderhandler('scrollBack')} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle opacity="1" cx="24" cy="24" r="24" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.2071 29.2071C20.8166 29.5976 20.1834 29.5976 19.7929 29.2071L15.2929 24.7071C14.9024 24.3166 14.9024 23.6834 15.2929 23.2929L19.7929 18.7929C20.1834 18.4024 20.8166 18.4024 21.2071 18.7929C21.5976 19.1834 21.5976 19.8166 21.2071 20.2071L18.4142 23H32C32.5523 23 33 23.4477 33 24C33 24.5523 32.5523 25 32 25H18.4142L21.2071 27.7929C21.5976 28.1834 21.5976 28.8166 21.2071 29.2071Z" fill="black"/>
                    </svg>
                    <svg onClick={()=>sliderhandler('scrollForward')}  width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle opacity="1" cx="24" cy="24" r="24" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M26.7929 18.7929C27.1834 18.4024 27.8166 18.4024 28.2071 18.7929L32.7071 23.2929C33.0976 23.6834 33.0976 24.3166 32.7071 24.7071L28.2071 29.2071C27.8166 29.5976 27.1834 29.5976 26.7929 29.2071C26.4024 28.8166 26.4024 28.1834 26.7929 27.7929L29.5858 25H16C15.4477 25 15 24.5523 15 24C15 23.4477 15.4477 23 16 23H29.5858L26.7929 20.2071C26.4024 19.8166 26.4024 19.1834 26.7929 18.7929Z" fill="black"/>
                    </svg>
                </div>
                <div ref={cardsPlaceHolderRef} className="portfolio-works-section_cards-placeholder">
                    <div style={{gridTemplate: `440px/repeat(${sldierCards.length},${window.innerWidth<=992?'310px':'390px'})`,left:`${scrollVal}px`}} className="portfolio-works-section_cards-carousel">
                        {sldierCards.map(p=>
                            <div key={p} className="portfolio-works-section_card">
                                <div className="portfolio-works-section_card-bg -ibg">
                                    <img src={require('../../../static/image-bg-portfolio-works.jpg')}/>
                                </div>
                                <div className="portfolio-works-section_card-body">
                                    <h1>Red Finger Building{p}</h1>
                                    <span>Business Centers</span><br/>
                                    <a href="#"><p>View Project</p></a>
                                </div>
                            </div>
                        )}
                    </div>
                    

                </div>
            </div>
        </div>
    )
}